export default {
    en: {
        no: 'No',
        select: 'Select',
        points: 'Points',
        total: 'Total',
        noData: 'No Data',
        year: 'Y',
        month: 'M',
        viewPage:'View all pages',

        list: {
            judgmentYn: 'Evaluation',
            judgmentY: 'Reflected',
            judgmentN: 'Excepted',
        },

        detail: {
            judgmentYn: 'Applicability of Evaluation',
            judgmentY: 'Applicable',
            judgmentN: 'Not Applicable',
            numOfAuthors: 'Number of authors',
            classification: 'Classification',
            professor: 'Faculty',
            researcher: 'Research Faculty and FullTime Researcher',
            helper: 'Ph.D. Candidate and Research Member',
            inCampus: 'In-Campus',
            offCampus: 'Off-Campus 1',
            abCampus: 'Off-Campus 2',
        },

        selectBox:{
            year: 'Year',
            term: 'Term {count}',
            select: 'Select',
        },

        alert:{
            authOrCheckErr:'Not authorized or confirmed.',
            authErr:'Not authorized.',
            validationErr:'Required fields are missing or the values entered are incorrect.',
            blankParams:'Please enter keywords.',
        },

        cnt:{
            person:'{count} people | {count} person | {count} people',
            zTerm:'Term {count}',
        },

		btn: {
			language: '한국어'
		}
    },
    ko: {
        no: '번호',
        select: '선택',
        points: '점수',
        total: '전체',
        noData: '표시할 데이터가 없습니다.',
        year: '년',
        month: '월',
        viewPage:'페이지 전체보기',

        list: {
            judgmentYn: '심사여부',
            judgmentY: '심사반영',
            judgmentN: '심사제외',
        },

        detail: {
            judgmentYn: '심사반영여부',
            judgmentY: '심사반영',
            judgmentN: '심사제외',
            numOfAuthors: '저자수',
            classification: '구분',
            professor: '교원',
            researcher: '비전임교원 및 전임연구원',
            helper: '박사 후 과정 및 기타',
            inCampus: '교내',
            offCampus: '교외1',
            abCampus: '교외2',
        },

        selectBox:{
            year: '학년도',
            term: '{count}학기',
            select: '선택',
        },

        alert:{
            authOrCheckErr:'승인되지 않았거나 확인하지 않은 항목입니다.',
            authErr:'승인되지 않은 항목입니다.',
            validationErr:'필수 항목이 누락되었거나 입력한 값이 잘못되었습니다.',
            blankParams:'검색어를 입력해주십시오.',
        },

        cnt:{
            person:'{count} 명 | {count} 명 | {count} 명',
            zTerm:'{count}학기',
        },

		btn: {
			language: 'English'
		}
    }
}